export enum PropertyMapType {
  FROM_OBJECT = 'FROM_OBJECT',
  FROM_INLINE_VALUE = 'FROM_INLINE_VALUE',
}
